import Axios from "axios";
import { Auth } from "aws-amplify";

const api = Axios.create({ baseURL: process.env.VUE_APP_API_URL });

api.interceptors.request.use(async (config) => {
  try {
    const user = await Auth.currentAuthenticatedUser();
    config.headers.Authorization = `Bearer ${user.signInUserSession.idToken.jwtToken}`;
  } catch (exp) {
    console.info("cant attach auth header", exp);
  }
  return config;
});

export default api;
